import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { customValidation, validations } from "../../../commonFunctions/CommonFunctions";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import WSPhone from "../../../Components/Phone/WSPhone";

export const OtherInformation: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
      <Grid container  spacing={2}>
        <Grid item xs={12} sm={3}>
          <Typography>Contact No</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSPhone label={""} id={"contactno"} name={"contactno"} control={control}/>

        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Person Name</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("personname")}
            id="personname"
            name="personname"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Agent Name</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("agentname")}
            id="agentname"
            name="agentname"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Email</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSTextField
            control={control}
            id="email"
            {...register("email")}
            type={TextType.Text}
            rules={customValidation(true, validations.email)}
            name="email"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Remark</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSTextAreaField
                  label={""}
                  id={"remark"}
                  name={"remark"}
                  control={control}
                  rules={{ required: false }}
                  rows={3}
                />         
        </Grid>
        
      </Grid>
  );
});
